/* eslint-disable no-bitwise */

import { v4 as uuidv4 } from 'uuid';
import type { SFC32Seed } from './sfc32';
import { sfc32 } from './sfc32';

export class ConsistentUuidV4Generator {
  private rng: () => number;
  public constructor(seed: SFC32Seed) {
    this.rng = sfc32(seed);
  }

  public uuidv4(): string {
    const inputBuffer : number[] = [];
    for (let i = 0; i < 16; i++) {
      inputBuffer.push(this.rng() % 0xFF);
    }
    return uuidv4({ random: inputBuffer });
  }
}
